import { render, staticRenderFns } from "./serviceResources.vue?vue&type=template&id=056fde77&"
import script from "./serviceResources.vue?vue&type=script&lang=js&"
export * from "./serviceResources.vue?vue&type=script&lang=js&"
import style0 from "./serviceResources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports